import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const quickChart = defineConnector({
  identifier: "quickChart",
  name: "QuickChart",
  tagLine: "Chart and QR code image API",
  logo,
  protocol: "http",
  tags: ["data", "documents"],
  defaultUrlPattern: () => "https://quickchart\\.io/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Copy your QuickChart API key",
      items: [
        {
          kind: "markdown",
          content:
            "QuickChart gives you an API key when you sign up. Their docs show sending the key as a `key` GET parameter, or inside the POST body for `/chart` requests.",
        },
      ],
    },
    {
      title: "Enter your QuickChart API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      `https://quickchart.io/chart?c=${encodeURIComponent(
        JSON.stringify({
          type: "bar",
          data: { labels: ["A"], datasets: [{ data: [1] }] },
        })
      )}`,
  },
});
